import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, User, Loader2, Gamepad2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/assets";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("psgc_token")) {
      api.get("/admin/me").then(() => nav("/admin/dashboard")).catch(() => localStorage.removeItem("psgc_token"));
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { username, password });
      localStorage.setItem("psgc_token", r.data.token);
      toast.success("Welcome back, Admin");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Invalid credentials"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="glass rounded-3xl p-8 w-full max-w-md animate-in">
        <img src={LOGO_URL} alt="" className="w-20 h-20 rounded-2xl object-cover mx-auto mb-4" />
        <h1 className="font-display text-2xl font-bold text-center tracking-wide">ADMIN LOGIN</h1>
        <p className="text-center text-sm text-slate-400 mb-6">Play Station Gaming Café Dashboard</p>
        <div className="space-y-4">
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
            <Input data-testid="admin-username-input" type="email" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Email" className="pl-10 h-12 bg-purple-950/30 border-purple-500/30" />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
            <Input data-testid="admin-login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="pl-10 h-12 bg-purple-950/30 border-purple-500/30" />
          </div>
        </div>
        <Button data-testid="admin-login-btn" disabled={loading} className="w-full h-12 mt-6 bg-purple-600 hover:bg-purple-500 font-semibold">
          {loading ? <Loader2 className="animate-spin" /> : <><Gamepad2 size={18} /> LOGIN</>}
        </Button>
        <a href="/" className="block text-center text-sm text-slate-500 mt-4 hover:text-purple-300">← Back to booking</a>
      </form>
    </div>
  );
}
